<template>
  <div>
    <v-card flat>
      <v-card-title>Artikelübersicht</v-card-title>
      
    </v-card>
    <v-simple-table dense class="body-2 grey--text ml-6">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Artikelbezeichnung
            </th>
            <th class="text-center">
              Preis
            </th>
            <th class="text-center">
              Anzahl
            </th>
            <th class="text-center">
              Gesamt
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in $store.state.cart" :key="product.title">
            <td class="greend--text">{{ product.itemId.title }}</td>
            <td class="text-center">
              {{ product.itemId.price.toFixed(2).replace(".", ",") }} €
            </td>
            <td class="text-center">{{ product.quantity }}</td>
            <td class="text-center">
              {{
                (product.itemId.price * product.quantity)
                  .toFixed(2)
                  .replace(".", ",")
              }}
              €
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card flat class="mt-8">
      <v-card-title class="pb-0">Zahlungsart</v-card-title>
      <v-card-text class="ml-4 my-0 py-0">
        <v-radio-group
          v-model="zahlungsart"
          column
          class="pa-0 ma-0"
        >
          <v-card flat class="pa-0 ma-0">
            <span v-if="hintZahlungsart" class="red--text caption font-weight-bold" 
          >Bitte wählen Sie eine Zahlungsart.</span
        >
            <v-row>
              <v-col>
                <v-radio
                  label="Vorkasse"
                  value="Vorkasse"
                  color="greend"
                > </v-radio>
                <v-card-text class="pa-0 pt-2 ma-0">
                  <span v-if="zahlungsart=='Vorkasse'" class="grey--text">
                    Die Zahlungsinformationen senden wir Ihnen binnen 2 Arbeitstagen mit der Bestellbestätigung per E-Mail.</span>
                </v-card-text>
              </v-col>
              <v-col v-if="total<40">
                <v-radio
                  label="Rechnung"
                  value="Rechnung"
                  color="greend"
                ></v-radio>
              </v-col>
            </v-row>
          </v-card>
        </v-radio-group>
      </v-card-text>
    </v-card>
    <v-card flat class="pa-0">
      <v-card-title class="pt-0">Rechnungs- und Versandadresse</v-card-title>
      <v-card-text class="ml-4">
        <p>
          <span class="font-weight-bold"
            >{{ this.$store.state.firstName }} {{ this.$store.state.lastName
            }}<br
          /></span>
          {{ this.$store.state.street }}<br />
          {{ this.$store.state.plz }} {{ this.$store.state.city }}
        </p>
        <b>E-Mail:</b> {{ this.$store.state.email }}<br />
        <span v-if="this.$store.state.comment"
          ><b>Kommentar:</b> {{ this.$store.state.comment }}</span
        >
      </v-card-text>
    </v-card>
    <v-card outlined class="px-4 py-2 mt-6">
      <v-form>
        <v-container fill-height fluid>
          <v-row no-gutters>
            <v-col cols="1">
              <v-checkbox v-model="checkbox" class="dataSec" color="greend" required>
              </v-checkbox>
            </v-col>
            <v-col>
              <span style="font-size:0.8em">
                Ich erkläre mich mit den
                <router-link to="impressum">AGB</router-link> einverstanden und
                die
                <router-link to="impressum">Widerrufsbelehrung</router-link>
                habe ich zur Kenntnis genommen. Ich stimme zu, dass meine
                Angaben und Daten elektronisch erhoben und gespeichert werden.
                Sie können Ihre Einwilligung jederzeit für die Zukunft per
                E-Mail an
                <a :href="`mailto:${email.addr}`">{{ email.text }}</a>
                widerrufen.
              </span>
            </v-col>
          </v-row>
        </v-container>
        <span v-if="hint" class="red--text caption font-weight-bold"
          >Bitte bestätigen Sie den Hinweis.</span
        >
      </v-form>
    </v-card>
    <v-row no-gutters class="mt-8">
      <v-col align="right">
        <v-btn
          class="ma-2"
          :loading="loadingSubmit"
          :disabled="loadingSubmit"
          color="greenb"
          @click="submit"
        >
          <span class="white--text">
            Zahlungspflichtig bestellen
          </span>
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon color="greend">mdi-sync</v-icon>
            </span>
          </template>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    checkbox: false,
    hint: false,
    hintZahlungsart: false,
    loader: null,
    loadingOrder: false,
    loadingSubmit: false,
    email: {
      addr: "mail@heberlein-kraeutertee.de",
      text: "mail@heberlein-kraeutertee.de"
    }
  }),
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 5000);
      this.loader = null;
    }
  },
  computed: {
    total() {
      // eslint-disable-next-line
      return (this.$store.state.cart.reduce((acc, product) => acc + (product.itemId.price * product.quantity), 0) + this.$store.state.shippingCost);
    },
    zahlungsart: {
get(){
  return this.$store.state.zahlungsart
},
set (value) {
  this.$ga.event("Checkout", "Zahlungsart geändert auf "+ value, "Zahlungsart neu: " + value);
  this.$store.commit('updateZahlungsart', value)
}
}
  },
  methods: {
    submit: function(e) {
      if (this.checkbox && this.zahlungsart) {
        this.loader = "loadingSubmit";
        this.hint = false;
        this.$store.state.datenverarbeitung = this.checkbox;
        this.$store.state.zahlungsart = this.zahlungsart;

        e.preventDefault();
        const messagesRef = this.$firebaseDatabase.collection("Bestellungen");
        messagesRef
          .add({
            firstName: this.$store.state.firstName,
            lastName: this.$store.state.lastName,
            street: this.$store.state.street,
            plz: this.$store.state.plz,
            city: this.$store.state.city,
            email: this.$store.state.email,
            zahlungsart: this.$store.state.zahlungsart,
            datenverarbeitung: this.$store.state.datenverarbeitung,
            time: new Date(),
            articles: this.$store.state.cart,
            comment: this.$store.state.comment,
            // eslint-disable-next-line
          total: (this.$store.state.cart.reduce((acc, product) => acc + product.itemId.price * product.quantity,0) + this.$store.state.shippingCost).toFixed(2).replace(".", ","),
            // eslint-disable-next-line
          sum: this.$store.state.cart.reduce((acc, product) => acc + product.itemId.price * product.quantity,0).toFixed(2).replace(".", ","),
            // eslint-disable-next-line
          mwst: ((this.$store.state.cart.reduce((acc, product) => acc + (product.itemId.price * product.quantity), 0))/1.07*0.07).toFixed(2).replace(".",","),
            // eslint-disable-next-line
          shippingCost: this.$store.state.shippingCost.toFixed(2).replace(".", ",")
          })
          .then(ref => {
            if (ref.id) {
              setTimeout(() => this.$router.push("orderConfirmation"), 2000);
            }
          })
          .catch(ref => {
            this.$ga.event(
              "Error",
              "Bestellung Fehlgeschlagen (Firebase)",
              ref
            ),
              setTimeout(() => this.$router.push("orderError"), 2000);
          });
          this.$ga.event("Checkout", "Bestellung übertragen (" + this.total + " €)", "Betrag (Total): " + this.total + " €");
      } else if (this.checkbox && !this.zahlungsart){
        this.hint = false;
        this.hintZahlungsart = true;
        this.$ga.event("Checkout", "Zahlungsart fehlt", "Zahlungsart nicht ausgewählt");
      } else if (!this.checkbox && this.zahlungsart){
        this.hint = true;
        this.hintZahlungsart = false;
        this.$ga.event("Checkout", "Datenschutz fehlt", "Datenschutz nicht zugestimmt");
      } else {
        this.hint = true;
        this.hintZahlungsart = true;
        this.$ga.event("Checkout", "Zahlungsart und Datenschutz fehlen", "Zahlungsart und Datenschutz fehlerhaft");
      }
    }
  }
};
</script>

<style scoped>
.dataSec >>> label {
  font-size: 0.8em;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
